jQuery(document).ready(function () {

	/**
	 * functions
	 */
	var $jsNavigation = jQuery('.js-navigation');
	var $jsSearchPanel = jQuery('.js-search-panel');
	var $searchAllIcon = jQuery('.js-search-all-icon');

	function openNavigation() {
		jQuery('.js-hamburger').addClass('js-hamburger-active');
		$jsNavigation.addClass('js-navigation-active');
	}

	function closeNavigation() {
		jQuery('.js-hamburger').removeClass('js-hamburger-active');
		$jsNavigation.removeClass('js-navigation-active');
		$jsNavigation.find('.js-sub-menu-icon').removeClass('jam-chevron-up');
		$jsNavigation.find('.sub-menu').addClass('hidden');
		$jsNavigation.find('.menu-item-has-children').removeClass('bg-whisper');
	}

	function closeSearchBox() {
		$searchAllIcon.children().addClass('jam-search');
		$jsSearchPanel.removeClass('js-search-panel-active');

		jQuery('.js-search-all').val('');
		jQuery('.js-search-panel-container').empty();
		$jsSearchPanel.children().append('<h3 class="font-sans text-tuna font-normal mb-1">Ange ditt sökord</h3>');
	}

	function openSearchBox() {
		jQuery(window).trigger('resize');
		$searchAllIcon.children().removeClass('jam-search');
		jQuery('.js-search-all').focus();
		$jsSearchPanel.addClass('js-search-panel-active');

		jQuery('.js-sticky-menu').removeClass('js-sticky-menu-active');
		jQuery('.js-sticky-welcome').removeClass('js-sticky-welcome-active');
		jQuery('.js-sticky-button').find('.jam').addClass('jam-envelope');

	}
	$searchAllIcon.on('click', function(e) {
		if($searchAllIcon.children('.jam-search').length === 0) {
			closeSearchBox();
		}
	});


	/**
	 * hamburger
	 */

	jQuery('.js-hamburger').on('click', function () {
		if (jQuery(this).hasClass('js-hamburger-active')) {
			closeNavigation();
		} else {
			openNavigation();
		}
	});


	/**
	 * navigation menu responsive
	 */

	// hide sub menu when mobile
	jQuery(window).on('lessThan-lg', function () {
		var $menuItemHasChildren = $jsNavigation.find('.menu-item-has-children');
		$menuItemHasChildren.children('.sub-menu').addClass('hidden');

		$menuItemHasChildren.find("a[href$='#']").on('click', function (e) {
			var $this = $(this);
			e.preventDefault();
			$this.find('.js-sub-menu-icon').toggleClass('jam-chevron-up');
			$this.parents('li').toggleClass('bg-whisper').find('.sub-menu').toggleClass('hidden');
		});

		$jsNavigation.find('.js-sub-menu-icon').on('click', function (e) {
			var $this = $(this);
			e.stopPropagation();
			e.preventDefault();
			$this.toggleClass('jam-chevron-up');
			$this.parents('li').toggleClass('bg-whisper').find('.sub-menu').toggleClass('hidden');

		});

	});

	// remove hide class as it triggers on hover when dekstop
	jQuery(window).on('greaterEqualTo-lg', function () {

		var $menuItemHasChildren = jQuery('.menu-item-has-children');
		var $linkChildren = $menuItemHasChildren.find("a[href$='#']");
		$linkChildren.unbind();
		$linkChildren.find('.js-sub-menu-icon').removeClass('jam-chevron-up');
		$linkChildren.parents('li').removeClass('bg-whisper').find('.sub-menu').removeClass('hidden');

		$menuItemHasChildren.removeClass('bg-whisper').children('.sub-menu').removeClass('hidden');
		$jsNavigation.removeClass('js-navigation-active');
		jQuery('.js-hamburger').removeClass('js-hamburger-active');
		$jsNavigation.find('.js-sub-menu-icon').removeClass('jam-chevron-up');
		jQuery(".js-sub-menu-icon").unbind("click");
	});


	/**
	 * search
	 */

	 // search all (input)
	jQuery(".js-search-all").on('click', function () {
		openSearchBox();
	});

	// when clicking inside any of the named classes don't do anything
	$jsSearchPanel.parent().on('click', function (e) {
		e.stopImmediatePropagation();
		e.stopPropagation();
	});

	// outside of the named classes do this
	jQuery(document).on('click', function () {
		closeSearchBox();
	})






		$(window).scroll(function() {
			var scroll = $(window).scrollTop();

			if (scroll <= 550) {
				$(".components-globals-navigation").removeClass("scrolled");
				$(".components-globals-navigation").removeClass("unscrolled");
			}

			else if (scroll >= 600) {
			$(".components-globals-navigation").addClass("scrolled");
			}

			else if (scroll <= 600 && $(".components-globals-navigation").hasClass("scrolled")) {
				$(".components-globals-navigation").addClass("unscrolled");

			}

		});



});
